<template>
  <new-layout
   :backgroundImage="backgroundImage"
   :showLogo="true"
   :backgroundImage2x="backgroundImage2x"
  >
    <error-card class="error-card"/>
  </new-layout>
</template>

<script>
import NewLayout from '../feature/login/components/NewLayout.vue';
import ErrorCard from '../components/ui/ErrorCard.vue';

export default {
  name: 'error',
  components: {
    NewLayout,
    ErrorCard,
  },
  metaInfo: {
    title: 'Error',
  },
  data() {
    return {
      backgroundImage: 'https://cdn.parcelex.com.br/assets/v3/persons/parcelex-guy-concerned.png',
      backgroundImage2x: 'https://cdn.parcelex.com.br/assets/v3/persons/parcelex-guy-concerned@2x.png',
    };
  },
};

</script>
